import React, { Component, Fragment } from 'react';
import { Redirect, BrowserRouter as Router, Route } from 'react-router-dom';

import { isAuthenticated } from 'api';
import Signup from './Signup/';
import Dashboard from './Dashboard/';
import Login from './Login/';
import RequestReset from './RequestPasswordReset/';
import UpdatePassword from './UpdatePassword/';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Redirect
          to={{
            pathname: '/dashboard',
            state: { from: props.location },
          }}
        />
      ) : (
        <Component {...props} />
      )
    }
  />
);

class App extends Component {
  render() {
    return (
      <Router>
        <Fragment>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PublicRoute exact path="/" component={Signup} />
          <PublicRoute path="/signup" component={Signup} />
          <Route path="/login" component={Login} />
          <Route path="/password/reset" component={RequestReset} />
          <PublicRoute path="/password/update" component={UpdatePassword} />
        </Fragment>
      </Router>
    );
  }
}

export default App;
